import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";

const mainPalette = {
  primary: { main: '#448aff', contrastText: '#ffffff' },
  secondary: { main: '#ffcc00' }
};

const themeInit = createMuiTheme({
  palette: mainPalette
});

export const mainTheme = {
  ...responsiveFontSizes(themeInit),
  overrides: {
    MuiDrawer: {
      paper: {
        backgroundColor: '#212121',
      },
    },
    MuiTooltip: {
      tooltip:{
        fontSize: '0.8rem'
      }
    }
  }
};
